<div class="lib-loader-wrapper size-{{ loaderSize }}">
    <div class="lib-loader-icon-wrapper" *ngIf="displayMode === 'both' || displayMode === 'icon'">
        <img src="/assets/loaders/loader_{{ loaderIcon }}.svg" alt="loader" class="lib-loader-icon theme-{{ loaderTheme }}">
    </div>
    <div class="lib-loader-text theme-{{ loaderTheme }}" *ngIf="displayMode === 'both' || displayMode === 'text'">
        {{ loaderText }}
    </div>
</div>
